module.exports = __webpack_public_path__ + "static/media/picard1.31f23187.jpg";